<button mat-mini-fab (click)="toggleEditMode()" class="admin-theme">
  <mat-icon>{{ isEditMode() ? 'visibility' : 'edit' }}</mat-icon>
</button>
